<template>
  <div class="card">
    <div class="card-header">
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-12">
            <span class="card-title float-left">{{tableTitle}}</span>
            <slot name="header">
              <router-link
                v-for="(btn,i) in buttons"
                :key="i"
                :to="btn.url"
                class="btn btn-success mr-2 btn-sm float-right"
              >{{btn.text}}</router-link>
            </slot>
          </div>
        </div>
      </div>
    </div>
    <!-- /.card-header -->
    <div class="card-body table-responsive">
      <div class="d-flex justify-content-between">
        <label class="d-md-flex mr-3">
          <select v-model="datatable.length" @change="getData()" class="form-control mx-2">
            <option v-for="(records, index) in perPage" :key="index" :value="records">{{records}}</option>
          </select>
        </label>
        <label class="d-md-flex">
          <input
            class="form-control"
            type="text"
            v-model="datatable.search"
            placeholder="Search Table"
            @input="getData()"
          />
        </label>
      </div>

         <slot 
      v-if="loading" 
      name="loading" 
      class="d-flex justify-content-center card">
      <h5 class="text-center">Processing...</h5>
      </slot>

      <table v-else class="table" :class="tableClassString">
        <thead>
          <slot name="table-head" v-bind="columns">
            <tr>
              <th
                v-for="(column,i) in columns"
                :style="{width:column.width}"
                :key="i"
                v-text="title(column)"
              >
              </th>
            </tr>
          </slot>
        </thead>
        <tbody>
          <slot name="table-body" v-bind="data"></slot>
        </tbody>
        <tfoot v-if="footer">
          <tr>
            <th v-for="(column,i) in columns" :key="i" v-text="title(column)"></th>
          </tr>
        </tfoot>
      </table>
   

      <slot v-if="error" name="error" >
           something went wrong
      </slot>


    </div>
    <!-- /.card-body -->
    <div class="card-footer clearfix">
      <Pagination
        :pagination="pagination"
        @prev="getData(pagination.prevPageUrl)"
        @next="getData(pagination.nextPageUrl)"
      ></Pagination>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/datatable/Pagination.vue";

import { mapState } from "vuex";
export default {
  components: {
    Pagination,
  },

  computed:{
    ...mapState({
    loading: (state) => state.loading,
    onLine: (state) => state.auth.onLine,
  }),

      tableClassString(){
       return this.tableClasses.join(' ')
      }
  },

  data() {
    let sortOrders = {};
    this.columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });
    return {
      state: "idle",
      datatable: {
        draw: 0,
        length: 100,
        search: "",
        column: 0,
        dir: "desc",
      },
      data: {},
      error: null,
      sortKey: "deadline",
      sortOrders: sortOrders,
      perPage: ["10", "20", "30", "100", "500"],
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
      },
    };
  },

  props: {
    footer: { default: false },
    columns: { type: Array },
    options: {},
    tableTitle: { type: String, default: 'Unknown Title' },
    buttons: { type: Array, default: () => [] },
    tableClasses:{ type: Array, default: () => [] },
    fetchData: {type: Function, required: false},
    link:{type: String, required: false}
  },

  created() {
      this.getData();
  },

  watch:{
    stationId(){
        this.getData();
    }

  },

  methods: {
    async getData() {
      
      try {

        this.datatable.draw++;
         let response = await  this.fetchData({ params: {...this.datatable, station: this.stationId } } )
          
        if (this.datatable.draw == response.meta.draw) {
          this.data = this.dataNormalisation(response.data);
          this.configPagination(response);
        }
      } catch (error) {
        this.error = error;
       
      }
    },

    dataNormalisation(data) {
      for (let index = 0; index < data.length; index++) {
        data[index]._count = index + 1;
      }

      return data;
    },

    title(column) {
      return column.label || this.titleCase(column.name);
    },
    titleCase(str) {
      return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    },

    configPagination(data) {
      this.pagination.lastPage = data.meta.last_page;
      this.pagination.currentPage = data.meta.current_page;
      this.pagination.total = data.meta.total;
      this.pagination.lastPageUrl = data.links.last;
      this.pagination.nextPageUrl = data.links.next;
      this.pagination.prevPageUrl = data.links.prev;
      this.pagination.from = data.meta.from;
      this.pagination.to = data.meta.to;
    },
    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.datatable.column = this.getIndex(this.columns, "name", key);
      this.datatable.dir = this.sortOrders[key] === 1 ? "asc" : "desc";
      this.getData();
    },
    getIndex(array, key, value) {
      return array.findIndex((i) => i[key] == value);
    },
  },
};
</script>

<style scoped>

.card-body > .table > thead > tr > th, .card-body > .table > thead > tr > td {
    border-top-width: 1px;
}
</style>

